import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../utils/index.js";
import { cdnIconVariants } from "./CdnIcon.variants.js";
const CdnIcon_CdnIcon = /*#__PURE__*/ forwardRef(function({ className, iconName, title, 'data-testid': dataTestId, ...props }, ref) {
    const classes = cn(cdnIconVariants(props), 'notranslate', className);
    return iconName ? /*#__PURE__*/ jsx("span", {
        ref: ref,
        className: classes,
        title: title,
        "data-testid": dataTestId,
        children: iconName
    }) : /*#__PURE__*/ jsx("span", {
        ref: ref,
        "data-testid": "empty-icon",
        className: classes,
        title: title
    });
});
export { CdnIcon_CdnIcon as CdnIcon };
